import { render, staticRenderFns } from "./posterTreeDetail.vue?vue&type=template&id=d428b536&scoped=true&"
import script from "./posterTreeDetail.vue?vue&type=script&lang=js&"
export * from "./posterTreeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d428b536",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d428b536')) {
      api.createRecord('d428b536', component.options)
    } else {
      api.reload('d428b536', component.options)
    }
    module.hot.accept("./posterTreeDetail.vue?vue&type=template&id=d428b536&scoped=true&", function () {
      api.rerender('d428b536', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/market/posterManage/posterTreeDetail.vue"
export default component.exports